import { busbar_registry } from "./busbar_registry";
import { formatDateTime, random, round2,getRandomPastDateOfCurrentMonth } from "../helpers/helpers";

export const generate_busbar_latest_data_demo = ({ meter_id }) => {
    let sensorRef = null;

    busbar_registry.forEach(loc => {
        loc.sensors.forEach(s => {
            if (s.meter_id === Number(meter_id)) {
                sensorRef = s;
            }
        });
    });

    if (!sensorRef) return null;

    const tempR = round2(random(24, 32));
    const tempY = round2(random(24, 32));
    const tempB = round2(random(24, 32));

    return {
        sensor_name: sensorRef.sensor_name,
        status: "Online",
        last_seen: formatDateTime(new Date()),

        temperature_r: tempR,
        temperature_y: tempY,
        temperature_b: tempB,

        /* -------- DAILY -------- */
        daily_avg_temp_r: round2(random(25, 30)).toFixed(2),
        daily_avg_temp_y: round2(random(25, 30)).toFixed(2),
        daily_avg_temp_b: round2(random(25, 30)).toFixed(2),

        daily_max_temp_r: round2(random(30, 34)).toFixed(2),
        daily_max_temp_r_time: "14:20",
        daily_max_temp_y: round2(random(30, 34)).toFixed(2),
        daily_max_temp_y_time: "14:10",
        daily_max_temp_b: round2(random(30, 34)).toFixed(2),
        daily_max_temp_b_time: "14:30",

        daily_min_temp_r: round2(random(23, 25)).toFixed(2),
        daily_min_temp_r_time: "05:40",
        daily_min_temp_y: round2(random(23, 25)).toFixed(2),
        daily_min_temp_y_time: "05:35",
        daily_min_temp_b: round2(random(23, 25)).toFixed(2),
        daily_min_temp_b_time: "05:50",

        /* -------- MONTHLY -------- */
        monthly_avg_temp_r: round2(random(25, 28)).toFixed(2),
        monthly_avg_temp_y: round2(random(25, 28)).toFixed(2),
        monthly_avg_temp_b: round2(random(25, 28)).toFixed(2),

        monthly_max_temp_r: round2(random(32, 35)).toFixed(2),
        monthly_max_temp_y: round2(random(32, 35)).toFixed(2),
        monthly_max_temp_b: round2(random(32, 35)).toFixed(2),

        monthly_min_temp_r: round2(random(22, 24)).toFixed(2),
        monthly_min_temp_y: round2(random(22, 24)).toFixed(2),
        monthly_min_temp_b: round2(random(22, 24)).toFixed(2),
        monthly_min_temp_y_date: getRandomPastDateOfCurrentMonth(),
        monthly_min_temp_r_date: getRandomPastDateOfCurrentMonth(),
        monthly_min_temp_b_date: getRandomPastDateOfCurrentMonth(),

        monthly_max_temp_y_date: getRandomPastDateOfCurrentMonth(),
        monthly_max_temp_r_date: getRandomPastDateOfCurrentMonth(),
        monthly_max_temp_b_date: getRandomPastDateOfCurrentMonth(),
    };
};